export enum PaymentTypeEnum {
  LIABILITY = 'INVOICE',
  BALANCE = 'BALANCE'
}

export class PaymentMethodMapper {
  static fromParam(type: string) {
    return type === 'balance' ? PaymentTypeEnum.BALANCE : PaymentTypeEnum.LIABILITY;
  }
}
